module.exports = __webpack_public_path__ + "static/media/t19.125158fe.jpg";